import { inject, observer } from 'mobx-react';
import { action, observable, toJS } from 'mobx';
import AgGrid from '../../../common/components/ag-grid/ag-grid';
import { AppConstants, APIUrlConstants } from '../../../common/APIConstants';
import React from 'react';
import DatePicker from 'react-datepicker';

import EstimatedLeakStartComponent from './estimatedleakstart';
import LeakDetectionTimeComponent from './leakdetectiontime';
import ApprovedOnComponent from './approvedon';
import { format, isValid, toDate } from "date-fns";

import moment from 'moment';
import CheckboxRenderer from '../../../common/CheckboxRenderer';
import UploadButtonRenderer from '../../../common/UploadButtonRenderer';
import StatusButtonRenderer from '../../../common/StatusButtonRenderer';
import EventHyperlinkRenderer from '../../../common/EventHyperlinkRenderer';
import SmartSelectClearable from '../../../common/SmartSelectClearable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Button, Container} from 'react-bootstrap';
import { BsSaveFill } from "react-icons/bs";
import { FaFileExport, FaRedditSquare, FaVoteYea } from "react-icons/fa";
import { FaRegTimesCircle } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { FcApproval } from "react-icons/fc";
import { FcApprove } from "react-icons/fc";


import {
  faCopy,
  faFileExport,
  faPlus,
  faSave,
  faSync,
  faTrash,
  faEye,
  faCircleNotch,
} from '@fortawesome/free-solid-svg-icons';
import commonstore from '../../../common/commonstore';
import ReleaseIncidentDataStore from '../store/release-incident-store';
import {
  DateFormatter,
  DateTimeFormatter,
  DateTimeAndFormatter
} from '../../../common/DateFormatter';
import {
  DecimalFormatter,
  NumberFormatter,
  DecimalAllDigitsFormatter
} from '../../../common/NumberFormatter';
import { NumericCellEditor } from '../../../common/NumericCellEditor';
import { DecimalCellEditor } from '../../../common/DecimalCellEditor';
import '../component/release-incident-screen.scss';
import { AsyncCreatable } from 'react-select';

/* react final form Start */
import { render } from 'react-dom';
import { Form, Field, FormSpy } from 'react-final-form';
import { OnChange } from "react-final-form-listeners";
import arrayMutators from 'final-form-arrays'
import { FieldArray } from "react-final-form-arrays";
import { downloadExcel } from "react-export-table-to-excel";

import { withRouter } from 'react-router-dom';
import { autoUpdateUOMFields, validate, REQUIRED, isReadWriteRole } from '../../../constants/releaseIncident';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

/* EXCEL EXPORT */
const header = ["Firstname", "Lastname", "Age"];
    const body = [
      ["Edison", "Padilla", 14],
      ["Cheila", "Rodrigez", 56],
    ];

// var  estimatedLeakStartDate = '';
// var  leakDetectionTimeDate = '';

const required = (value) => value ? undefined : 'Required'
const mustBeNumber = value => (isNaN(value) ? 'Must be a number' : undefined)
const minValue = min => value =>
  isNaN(value) || value >= min ? undefined : `Should be greater than ${min}`
const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined)

/* react final form End */



const FileBrowser = (props) => (
  <div className="row otgmodel-row"><input type="file" name={'File' + props.id} key={props.id} onChange={props.handler.handleFileChange}></input></div>
);

@inject('ReleaseIncidentDataStore')
@observer
class ReleaseIncidentScreen extends React.Component {
  @observable dateSelection = {
    estimatedLeakStart:'',
    leakDetectionTime:'',
    approvedOn:''
  };
  constructor(props) {
    super(props);

    //this.downloadCall = this.downloadCall.bind(this);
    

    //console.log(_isLinkUrl);

    this.state = {
      gridOptions: {

        rowSelection: 'single',
        singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowGroupPanelShow: 'always',
        suppressContextMenu: true,
        getRowStyle: this.getRowStyleScheduled,
        statusBar: {
          statusPanels: [
            {
              statusPanel: 'agTotalAndFilteredRowCountComponent',
              align: 'left'
            },
            {
              statusPanel: 'agAggregationComponent',
              statusPanelParams: {
                aggFuncs: ['avg', 'count', 'min', 'max', 'sum']
              }
            }
          ]
        },
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel'
            }
          ],
          showToolPanel: false
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true
        },
        frameworkComponents: {
          SmartSelectClearable: SmartSelectClearable,
          booleanCellEditor: CheckboxRenderer,
          numericCellEditor: NumericCellEditor,
          decimalCellEditor: DecimalCellEditor,
          dateFormatter: DateFormatter,
          dateTimeFormatter: DateTimeAndFormatter,
          uploadButtonRenderer: UploadButtonRenderer,
          statusButtonRenderer: StatusButtonRenderer,
          eventHyperlinkRenderer: EventHyperlinkRenderer
        }
      },
      editRowData: '',
      rowSelected: false,
      eventYearTxt: '',
      divisionTxt: '',
      districtTxt: '',
      locationTxt: '',
      isSubmitting: false,
      currentColumnDef: [],
      showFileModal: false,
      newFiles: [],
      uploadedFiles: [],
      newFilesObject: {},
      currentLeakDetectionData: [],
      leakLocationNumber:'',
      showLeakDetectionModal: false,
      // estimatedDate: new Date(),
      // estimateLeakdDate: new Date(),
      estimatedLeakStart:new Date(),
      leakDetectionTime:new Date(),
      approvedOn:new Date(),
      submitType:0,
      singleGridData:[],
      storeDateForm:[],
      isDisabled:false,
      approverStatus:false
    };
  }
  getRowStyleScheduled = (params) => {
    return null;
  };

  /* Release incident list */
  releaseIncidentList = async ()=>{
    await this.getReleaseIncidentsData();
  }

  /* Form Submission with button */
  leakForm = async (values)=>{
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    const { currentLeakDetectionData, submitType } = this.state
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN');
    const roleObj = JSON.parse(jsonStringOBJ);
    const { displayName } = roleObj;
    const lastUpdateBy = currentLeakDetectionData['lastUpdateBy']
    const dataHasNotBeenChanged = JSON.stringify(values) === JSON.stringify({...currentLeakDetectionData})
    /* 
    * BASE ON TYPE CALL THE API 
    * --Save - Type-1
			1) Save API
			2) Update LDS Status API
		
		--Submit for Approval - Type-2 
			1) Save API
			2) Send Mail API
			3) Update LDS Status API
    */
    
    let formSubmit = await ReleaseIncidentDataStore.leakFormSubmit(values, CommonStore, submitType, 
      lastUpdateBy, dataHasNotBeenChanged
    );
    
    if(formSubmit){
      let update_status = '';
      let event_id = this.state.currentLeakDetectionData.ticketId;

      /*if(this.state.submitType==1){
        //this is save
        update_status = 'In Progress';
      }
      else if(this.state.submitType==2)
        update_status = 'Submit for Approval';
      else if(this.state.submitType==3)
        update_status = 'Approved';
      */
        
      switch(this.state.submitType){
        case 1:
          update_status = 'In Progress';
        break;
        
        case 2:
          update_status = 'Submit for Approval';
        break;

        case 3:
          update_status = 'Approved';
        break;

        case 4:
          //Reject
          update_status = 'In Progress';
        break;

        default:
          update_status = 'In Progress';
        break;
      }


      let updateData = {"eventId": event_id,"status": update_status,"ReviewApprovedBy":displayName,"ApprovedOn": moment().format('YYYY-MM-DD HH:mm:ss')}

      
      /* Leak detectoin form status update */
      let updateApiCall = await ReleaseIncidentDataStore.LeakDetectionStatusUpdate(updateData, CommonStore,this.state.submitType,values,event_id,this.state.singleGridData);

      /*if(this.state.submitType==2 && updateApiCall){
        let mailContent = {
          "emailTemplate": null,
          "eventId": event_id,
          "title": this.state.singleGridData.title,
          "division": values.ldsResponseDivision,
          "district": values.ldsResponseDistrict,
          "locaion": values.leakLocation,
          "eventDate": moment(this.dateSelection.leakDetectionTime).format('MM-DD-YYYY HH:mm:ss')
        }
        // Send mail API 
        let sendApiCall = await ReleaseIncidentDataStore.sendMailApi(mailContent, CommonStore);
        
        if(sendApiCall){
          // FORM SUBMIT SUCCESS 
          window.toastr.success("Data Saved Sucessfully!");
          
        }

      }else{
        // FORM SUBMIT SUCCESS 
        window.toastr.success("Data Saved Sucessfully!");
      } */
      
      this.closeModal();

      this.releaseIncidentList();
      
      this.props.history.push('/reference/ReleaseIncidentScreen');
    }
  }

  /* 
  * LEAK DETECTION FORM SUBMIT 
  */
  onSubmit = async values => {
    // console.log('form submit');
    // console.log(this.dateSelection);
    
    this.leakForm(values);
  }

  /* APPROVE AND REJECT API CALLS */
  onApproveReject = async (type) => {
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN');
    const roleObj = JSON.parse(jsonStringOBJ);
    const { displayName } = roleObj;

    let update_status = '';
      let event_id = this.state.currentLeakDetectionData.ticketId;

      if(type==3)
        update_status = 'Approved';
      else if(type==4)
        update_status = 'In Progress';

      let updateData = {"eventId": event_id,"status": update_status,"ReviewApprovedBy":displayName,"ApprovedOn": moment().format('YYYY-MM-DD HH:mm:ss')}

      /* Leak detectoin form status update */
      let updateApiCall = await ReleaseIncidentDataStore.LeakDetectionStatusUpdate(updateData, CommonStore,type,'',event_id,this.state.singleGridData);

      // if(updateApiCall){
      //   let msg = type==3?'Approve is updated sucessfully!':'Reject is updated sucessfully!';
      //   window.toastr.success(msg);
      // }

      this.closeModal();
      this.releaseIncidentList();
      this.props.history.push('/reference/ReleaseIncidentScreen');
  }


  /* 
  * LEAK DETECTION EXCEL EXPORT
  */
  handleDownloadExcel = (data)=> {
    /*downloadExcel({
      fileName: "react-export-table-to-excel -> downloadExcel method",
      sheet: "react-export-table-to-excel",
      tablePayload: {
        header,
        // accept two different data structures
        body: body,
      },
    });
    */

    data['title'] = this.state.singleGridData.title

    let downloadBlob = ReleaseIncidentDataStore.releaseIncidentExcelDownload(data);

  }

  setColumnDef = async () => {
    const { CommonStore, VendortTemplateDataStore } = this.props;
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    //const currentScreenChildren = this.getCurrentScreenChildren();
    await ReleaseIncidentDataStore.setColumnDef(currentScreen, CommonStore, this.ShowFileModal, this.showLeakDetection);
  };
  getCurrentScreenChildren = () => {
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.parent === parentScreenName
    );

    return currentScreenChildren;
  };
  getCurrentScreenChildrenByNm = (screenName) => {
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName && x.screen.name == screenName
    );

    return currentScreenChildren;
  };
  handleEventYearChange = (e) => {
    var eventYearTxt = e.target.value;
    this.setState({ eventYearTxt: eventYearTxt });
    this.setState({ divisionTxt: '' });
    this.setState({ districtTxt: '' });
    this.setState({ locationTxt: '' });
    this.getDivisionData(eventYearTxt);
    ReleaseIncidentDataStore.resetReleaseIncidentData();
    e.preventDefault();
  };
  handleDivisionChange = (e) => {
    var divisionTxt = e.target.value;
    this.setState({ divisionTxt: e.target.value });
    this.setState({ districtTxt: '' });
    this.setState({ locationTxt: '' });
    this.getDistrictData(divisionTxt);
    ReleaseIncidentDataStore.resetReleaseIncidentData();
    e.preventDefault();
  };
  handleDistrictChange = (e) => {
    var districtTxt = e.target.value;
    this.setState({ districtTxt: districtTxt });
    this.setState({ locationTxt: '' });
    this.getLocationData(districtTxt);
    ReleaseIncidentDataStore.resetReleaseIncidentData();
    e.preventDefault();
  };
  
  handleLocationChange = (e) => {
    this.setState({ locationTxt: e.target.value });
    ReleaseIncidentDataStore.resetReleaseIncidentData();
    e.preventDefault();
  };

  downloadCall = (id,filename) => {
    let downloadBlob = ReleaseIncidentDataStore.releaseIncidentDownload(id,filename);
  };

  getDivisionData = async (eventYearTxt) => {
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    await ReleaseIncidentDataStore.getGetDivsion(eventYearTxt, CommonStore);
  }

  getDistrictData = async (divisionTxt) => {
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    const { eventYearTxt } = this.state;
    await ReleaseIncidentDataStore.getGetDistrict(eventYearTxt, divisionTxt, CommonStore);
  }

  getLocationData = async (districtTxt) => {
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    const { eventYearTxt, divisionTxt } = this.state;
    await ReleaseIncidentDataStore.getGetLocation(eventYearTxt, divisionTxt, districtTxt, CommonStore);
  }


  getReleaseIncidentsData = async () => {
    this.setState({ rowSelected: false, editRowData: '' });
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    const { eventYearTxt, divisionTxt, districtTxt, locationTxt } = this.state;
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    if(eventYearTxt!='')
      await ReleaseIncidentDataStore.getScreenData(currentScreen, eventYearTxt, divisionTxt, districtTxt, locationTxt, CommonStore);
    // this.ShowFileModal();
  }

  onSelectionChanged = async (e) => {
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    this.setState({ rowSelected: selectedRow.length, editRowData: selectedRow[0] });
  }
  ShowFileModal = async (ticketId) => {
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    this.setState({ currentIncident: ticketId, newFilesObject: {} });
    let uploadedFiles = await ReleaseIncidentDataStore.getIncidentFiles(ticketId, CommonStore);
    this.state.newFiles.length = 0;
    this.state.newFiles.push(1);
    this.setState({ showFileModal: true, newFiles: this.state.newFiles, uploadedFiles: uploadedFiles.data });

  }
  addNewFile = () => {
    this.state.newFiles.push(this.state.newFiles.length + 1);
    this.setState({ newFiles: this.state.newFiles });
  }
  uploadFile = async () => {
    let formData = new FormData();
    for (let filename in this.state.newFilesObject) {
      formData.append(filename, this.state.newFilesObject[filename]);
    }
    formData.append('incident', this.state.currentIncident);
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    await ReleaseIncidentDataStore.uploadIncidentFile(formData, CommonStore);
    this.state.newFiles = [];
    let uploadedFiles = await ReleaseIncidentDataStore.getIncidentFiles(this.state.currentIncident, CommonStore);
    this.setState({ newFiles: this.state.newFiles, newFilesObject: {} });
    this.state.newFiles.push(1);
    this.setState({ newFiles: this.state.newFiles, uploadedFiles: uploadedFiles.data });
  }
  handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      this.state.newFilesObject[event.target.files[0].name] = event.target.files[0];

    }
  }

  closeModal = async (ID) => {
    this.setState({ showFileModal: false, showLeakDetectionModal: false,submitType:0 })
    this.props.history.push('/reference/ReleaseIncidentScreen');
  }

  showLeakDetection = async (data) => {
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    
    // console.log('showLeakDetection');
    // console.log(data);

    var leakDetectiondata = await ReleaseIncidentDataStore.getLeakDetections({ EventNumber: data.ticketId }, CommonStore);
    
    if(typeof leakDetectiondata!='undefined' && leakDetectiondata.frontstatus){
      //let leakConsolidatedData = data;
      var leakConsolidatedData = [];
      let all = typeof leakDetectiondata!='undefined' && leakDetectiondata.data!=''?leakDetectiondata.data:[] ;
      
      let detection_str = [
        {
          "id": 1,
          "detectionId": 1,
          "ticketId": all.ticketId,
          "operation": "",
          "applicable": true,
          "detected": "",
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": "",
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Third Party Report"
        },
        {
          "id": 2,
          "detectionId": 2,
          "ticketId": all.ticketId,
          "operation": "",
          "applicable": null,
          "detected": null,
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Analog Pressure/Flow Monitoring"
        },
        {
          "id": 3,
          "detectionId": 3,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": "",
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Computational Pipeline Monitoring (CPM)"
        },
        {
          "id": 4,
          "detectionId": 4,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": null,
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": "",
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "CPM Detailed Review"
        },
        {
          "id": 5,
          "detectionId": 5,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": "",
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Low Discharge Pressure with Pump Running Rupture Detection"
        },
        {
          "id": 6,
          "detectionId": 6,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": null,
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Manual Over/Short"
        },
        {
          "id": 7,
          "detectionId": 7,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": null,
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Rate of Change Combination (ROCC) Rupture Detection"
        },
        {
          "id": 8,
          "detectionId": 8,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": null,
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "CPM Rupture Detection"
        },
        {
          "id": 9,
          "detectionId": 9,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": null,
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Stand Up Pressure Test"
        },
        {
          "id": 10,
          "detectionId": 10,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": null,
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Static Pressure Monitoring"
        },
        {
          "id": 11,
          "detectionId": 11,
          "ticketId": all.ticketId,
          "operation": null,
          "applicable": null,
          "detected": null,
          "indicatedAvgLeakRate": "",
          "expectedSwiftness": "",
          "comments": null,
          "lastLeakDetectedBy": "",
          "commentsAccuracyPerformance": "",
          "uom": "",
          "noteName": "Surveillance"
        }

    ];

      leakConsolidatedData['leakDetections'] = (all.leakDetections).length>0?all.leakDetections:detection_str;
      leakConsolidatedData['leakLocationNumber'] = all.leakLocationNumber;
      leakConsolidatedData['estimatedAvgLeakRateSelect'] = all.estimatedAvgLeakRateSelect;
      leakConsolidatedData['leakLocationUnit'] = all.leakLocationUnit;
      leakConsolidatedData['lsd'] = all.lsd;
      leakConsolidatedData['leakLocationSystem2'] = all.leakLocationSystem2;
      leakConsolidatedData['ldsResponseDivision'] = data.division;// all.ldsResponseDivision;
      leakConsolidatedData['ldsResponseDistrict'] = data.district; //all.ldsResponseDistrict;
      leakConsolidatedData['division'] = data.division;
      leakConsolidatedData['district'] = data.district;
      leakConsolidatedData['console'] = all.console;
      leakConsolidatedData['reviewApprovedBy'] = all.reviewApprovedBy;
      leakConsolidatedData['approvedOn'] = all.approvedOn;
      leakConsolidatedData['leakDetectionTime'] = all.leakDetectionTime;
      leakConsolidatedData['estMaximumUnit'] = all.estMaximumUnit;
      leakConsolidatedData['estMinimumUnit'] = all.estMinimumUnit;
      leakConsolidatedData['status'] = all.status;
      leakConsolidatedData['ticketId'] = all.ticketId;
      leakConsolidatedData['lastUpdateBy'] = all.lastUpdateBy;
      leakConsolidatedData['note'] = all.note;
      leakConsolidatedData['estimatedLeakStart'] = all.estimatedLeakStart;
      leakConsolidatedData['leakLocation'] = all.leakLocation;
      leakConsolidatedData['plm'] = all.plm;
      leakConsolidatedData['estimatedAvgLeakRate'] = all.estimatedAvgLeakRate;
      leakConsolidatedData['estimatedMax'] = all.estimatedMax;
      leakConsolidatedData['estimatedMin'] = all.estimatedMin;
      leakConsolidatedData['swiftnesOfDetection'] = all.swiftnesOfDetection;
      
      var estDate = all.estimatedLeakStart;
      var leadDtime = all.leakDetectionTime;

      this.setState({ 
        isDisabled:(all.status=='Approved'?true:false),
        singleGridData:data,
        currentLeakDetectionData: leakConsolidatedData,
        showLeakDetectionModal: true
      });
    }else{
      window.toastr.error(leakDetectiondata.message);
    }
    
    // console.log('leak location data')
    // console.log(this.state);
    
    // setTimeout(function(){ 
    //   console.log(this.state.currentLeakDetectionData); 
    // }, 2000);
    

  }
  state = () => {
    curDT: new Date().toLocaleString();
  }

  handleDateChange = async (estime) => {
    estime = moment(estime).format('MM-DD-YYYY HH:mm:ss');
    //this.estimatedLeakStartDate = estime;
    await ReleaseIncidentDataStore.estimatedLeakStartUpdate(estime);
    
    
    //console.log('estimatedLeakStartDate',this.estimatedLeakStartDate);
    // this.setState(state => {
    //   let leakUpdates = Object.assign({}, state.currentLeakDetectionData); 
    //   leakUpdates.estimatedLeakStart = estime;
    //   console.log('leak data',leakUpdates);
    //   return leakUpdates;
    // })

    // this.setState(prevState => ({
    //   currentLeakDetectionData: {                   // object that we want to update
    //       ...prevState.currentLeakDetectionData,    // keep all other key-value pairs
    //       estimatedLeakStart: estime       // update the value of specific key
    //   }
    // }))


  }

  handleLeakDateChange = (estime) => {
    this.setState(state => ({
      leakDetectionTime: estime,
    }))
  }

  approvedOnDate = (estime) => {
    this.setState(state => ({
      approvedOn: estime,
    }))
  }

  handleChange = (event)=> { 
    const height = event.target.scrollHeight; 
    const rows = event.target.rows; 
    const rowHeight = 15; 
    const trows = Math.ceil(height / rowHeight) - 1; 
    console.log(height, rows, trows); 
  }

  render() {

    const { headerDetails, screenRowData, hasScreenData, screenColumnDefinitions } = this.props.ReleaseIncidentDataStore;
    const { isSubmitting, eventYearTxt, currentLeakDetectionData } = this.state;

    var {dateSelection} = this.props.ReleaseIncidentDataStore;
    const parentScreen = this.getCurrentScreenParent();
    let colDef = screenColumnDefinitions['ReleaseIncidentScreen'];
    const isSubmitEnabled = (eventYearTxt != '') ? false : true;

    const mb_kp = [
      {key: 'mp', text: 'Mp', value: 'mp'},
      {key: 'kp', text: 'Kp', value: 'kp'}
    ] 

    const bph_m3 = [
      {key: 'bph', text: 'bph', value: 'bph'},
      {key: 'm3/h', text: 'm3/h', value: 'm3/h'},
      {key: 'N/A', text: 'N/A', value: 'N/A'}
    ]

    const yes_no_na = [
      {key: 'Yes', text: 'Yes', value: 'Yes'},
      {key: 'No', text: 'No', value: 'No'},
      {key: 'n/a', text: 'N/A', value: 'n/a'},
    ]

    const bph_m3h_NA = [
      {key: 'bph', text: 'bph', value: 'bph'},
      {key: 'm3/h', text: 'm3/h', value: 'm3/h'},
      {key: 'N/A', text: 'N/A', value: 'N/A'}
    ]
    const notApproved = (submitting,getState,approverStatus)=>{
      
      if(this.state.currentLeakDetectionData.status!='Approved'){
        if(isReadWriteRole()){
        return (<>
            <button 
              className="btn btn-primary btn-grid active" 
              type="button" 
              onClick={()=>{this.setState({submitType:1}, () => {this.leakForm(getState().values)})}} 
              disabled={submitting}
            >
              <FontAwesomeIcon icon={faSave} /> 
              Save
            </button>
          <button 
          className={"btn btn-primary btn-grid active w189 " + (approverStatus ? 'hideBtn' : '')}  
          type="submit" 
          onClick={()=>this.setState({submitType:2})}
          >
            <FontAwesomeIcon icon={faSave} /> 
            Submit for Approval
          </button>
        </>)
      }}else{
        return ('')
      }
    }


    const renderApproverButton = (submitting,getState) => {
      if (this.state.approverStatus) {
        return (
        <>
            {notApproved(submitting,getState,this.state.approverStatus)}
            {/* <button class="btn btn-primary btn-grid active" type="button" onClick={()=>this.onApproveReject(3)}><FontAwesomeIcon icon={faSave}  /> Approve</button>
            <button class="btn btn-primary btn-grid active" type="button" onClick={()=>this.onApproveReject(4)}><FontAwesomeIcon icon={faCircleNotch}  /> Reject</button> */}
            {isReadWriteRole() ?
              <>
                <button className="btn btn-primary btn-grid active" type="submit" onClick={()=>this.setState({submitType:3})}><FontAwesomeIcon icon={faSave}  /> Approve</button>
                <button className="btn btn-primary btn-grid active" type="submit" onClick={()=>this.setState({submitType:4})}><FontAwesomeIcon icon={faCircleNotch}  /> Reject</button> 
                <button className="btn btn-primary btn-grid active" type="button" onClick={()=>this.handleDownloadExcel(getState().values)}><FontAwesomeIcon icon={faFileExport} /> Export</button>
              </>
              : null
            }
            <button className="btn btn-primary btn-grid active" onClick={this.closeModal} type="button"><FontAwesomeIcon icon={faSync} /> Cancel</button>
                
        </>
        )
      }else{
        
        return(
          <>
            {notApproved(submitting,getState)}
            {isReadWriteRole() ? <button className="btn btn-primary btn-grid active" type="button" onClick={()=>this.handleDownloadExcel(getState().values)}><FontAwesomeIcon icon={faFileExport} /> Export</button> : null}
            <button className="btn btn-primary btn-grid active" onClick={this.closeModal} type="button"><FontAwesomeIcon icon={faSync} /> Cancel</button>
          </>
        )
      } 
    }

    const saveSubmitApproval = () => {
      if (this.state.currentLeakDetectionData.status!='In Progress') {
        return (
        <>
          <button className="btn btn-primary btn-grid active" type="submit" onClick={()=>this.setState({submitType:1})}><FontAwesomeIcon icon={faSave} /> Save</button>
          <button className="btn btn-primary btn-grid active w189 " type="submit" onClick={()=>this.setState({submitType:2})} ><FontAwesomeIcon icon={faSave} /> Submit for Approval</button>
        </>
        )
      } 
    }

    const parse = value => (isNaN(parseFloat(value)) ? "" : parseFloat(value));


    return (
      <div className="col-md-12 ">
        <div className="container cb-title-container">
          
          <h3 className="cb-title">{(typeof parentScreen!='undefined')?parentScreen.screen.title:''}</h3>
        </div>
        <div className="col-md-12">
          <div className="row nglteam-header-row  sticky-top rounded">
            <div className="col-md-2">
              <div className="row">
                <div className="col-md-6">
                  <label className="nglteam-header-row-label" >&nbsp;Event&nbsp;Year:</label>
                </div>
                <div className="col-md-6">
                  <select value={this.state.selectedFacility} onChange={this.handleEventYearChange}>
                    <option key="" value="">
                      Select Year
                    </option>
                    {headerDetails.eventDpDwnList.map((option) => (
                      <option key={option.eventYear} value={option.eventYear}>
                        {option.eventYear}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="row">
                <div className="col-md-4">
                  <label className="nglteam-header-row-label">&nbsp;Division:</label>
                </div>
                <div className="col-md-8">
                  <select value={this.state.selectedFacility} className="w-100" onChange={this.handleDivisionChange}>
                    <option key="" value="">
                      All Division
                      </option>
                    {headerDetails.divisionDpDwnList.map((option) => (
                      <option key={option.division} value={option.division}>
                        {option.division}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="row">
                <div className="col-md-4">
                  <label className="nglteam-header-row-label">&nbsp;District:</label>
                </div>
                <div className="col-md-8">
                  <select value={this.state.selectedFacility} className="w-100" onChange={this.handleDistrictChange}>
                    <option key="" value="">
                      All District
                    </option>
                    {headerDetails.districtDpDwnList.map((option) => (
                      <option key={option.district} value={option.district}>
                        {option.district}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-3">
                  <label className="nglteam-header-row-label">&nbsp;Location: </label>
                </div>
                <div className="col-md-9">
                  <select value={this.state.selectedFacility} className="w-100" onChange={this.handleLocationChange}>
                    <option key="" value="">
                      All Location
                    </option>
                    {headerDetails.locationDpDwnList.map((option) => (
                      <option key={option.location} value={option.location}>
                        {option.location}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="row">

                <div className="col text-center">
                  <button
                    type="submit"
                    disabled={isSubmitting || isSubmitEnabled}
                    className="nomination-btnsz btn btn-primary"
                    onClick={this.getReleaseIncidentsData}
                  >
                    {isSubmitting && (
                      <span className="spinner-border spinner-border-sm mr-1"></span>
                    )}
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={this.state.showFileModal} dialogClassName="otgmodal-80w">
          <Modal.Header className="otgmodel-header">
            <Modal.Title>Additional Files</Modal.Title>
          </Modal.Header>
          <Modal.Body className="otgmodel-body">
            <Container>

              {this.state.newFiles.map((r, i) => (
                <FileBrowser id={i} handler={this} ></FileBrowser>
              ))}

              <div>
                <button
                  type="button"
                  className="btn btn-primary  btn-grid active incidentpopupbuttons"
                  aria-expanded="false"
                  onClick={this.addNewFile}
                >   <FontAwesomeIcon icon={faPlus} /></button>
                <button
                  type="submit"
                  onClick={this.uploadFile}
                  className="btn btn-primary  btn-grid active incidentpopupbuttons pull-right"
                >Upload
                </button>
              </div>
              <br />
              <br />
              <h4>  Uploaded files</h4>
              <table>
                {this.state.uploadedFiles.map((r, i) => (
                  <tr key={i}>
                    <td>{r}</td>
                    <td>
                      {/* <a href={APIUrlConstants.DownloadReleaseIncidenFile.replace('{0}', this.state.currentIncident).replace('{1}', r)}>Download</a> */}
                      {/* onClick={this.downloadCall(this.state.currentIncident,r)} */}

                      <a href="javascript:void(0);" download onClick={()=>this.downloadCall(this.state.currentIncident,r)} >Download</a>
                      
                    </td>
                  </tr>
                ))}
              </table>

            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal} className="otgmodel-header">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showLeakDetectionModal} dialogClassName="otgmodal-80w">
          <Modal.Header className="otgmodel-header">
            <Modal.Title>Leak Detection Response Form : {this.state.singleGridData.ticketId} - {this.state.singleGridData.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="leakdetectionmodalbody release-screen-class">
            <Container>
                <Form
                  onSubmit={(e)=>this.onSubmit(e)}
                  mutators={{
                    // potentially other mutators could be merged here
                    ...arrayMutators
                  }}
                  validate={(values) => validate(values)}
                  initialValues={this.state.currentLeakDetectionData}
                  render={({ handleSubmit, form, submitting, pristine, values,form: { getState } }) => (
                    <form onSubmit={handleSubmit}>
                      
                      {/* Auto update all uom, estimated min & estimated max
                        field(s) whenever estimated avg leak rate selection changes
                      */}
                      {autoUpdateUOMFields.map(item => {
                        return (
                          <WhenFieldChanges
                            key={item.id}
                            field={"estimatedAvgLeakRateSelect"}
                            becomes={item.unit}
                            set={item.set}
                            to={item.unit}
                          />
                        )
                      })}

                      {/* Auto update all detected fields, whenever any system's 
                        operation fields changes
                      */}
                      {currentLeakDetectionData?.leakDetections?.length &&
                        currentLeakDetectionData.leakDetections.map((item, index) => {
                          return (
                            <WhenFieldChanges
                              key={item.id}
                              field={`leakDetections[${index}].operation`}
                              becomes={"n/a"}
                              set={`leakDetections[${index}].detected`}
                              to={"n/a"}
                            />
                          )
                        })
                      }
                    
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Estimated Leak Start (Time/Date):</label>
                        <div className="col-sm-8">
                          <EstimatedLeakStartComponent isDisabled={this.state.isDisabled} submitInfo={this.state.submitType}  />
                        </div>
                      </div>
                      
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Leak Location (System):</label>
                        <div className="col-sm-8">
                        <Field name="status" value="In Progress" component="input" type="hidden" />
                    
                        <Field name="leakLocation" validate={required}  >
                            {({ input, meta }) => (
                              <div>
                                <input 
                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                {...input} disabled={this.state.isDisabled}  className="form-control input-sm" type="text" />
                                
                                {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                              </div>
                            )}
                        </Field>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Leak Location (Mp/Kp):</label>
                        <div className="col-sm-2">
                          <Field name="leakLocationNumber" validate={required} >
                            {({ input, meta }) => (
                              <div>
                                <input 
                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                {...input} disabled={this.state.isDisabled} className="form-control" type="text" />
                                {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </div>
                        <div className="col-sm-2">
                          <Field name="leakLocationUnit" selected={this.state.currentLeakDetectionData.leakLocationUnit} options={mb_kp} validate={required}>
                            { ({input,  meta, options,selected}) => {
                                return (
                                    <Opts selected={selected} disabled={this.state.isDisabled} options={options} meta={meta} onChange={ (value) => input.onChange(value)} name={input.name}/>
                                )
                            }}
                          </Field>
                        </div>
                        <label className="col-sm-1 col-form-label text-right">LSD:</label>
                        <div className="col-sm-3">
                          <Field name="lsd" validate={required}>
                            {({ input, meta }) => (
                              <div>
                                <input 
                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                {...input} disabled={this.state.isDisabled} className="form-control" type="text" />
                                {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                      
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Division:</label>
                        <div className="col-sm-8">
                        { 
                          <Field name="ldsResponseDivision">
                          {({ input, meta }) => (
                            <div>
                              <input 
                              onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                              {...input} 
                              disabled={this.state.isDisabled}
                              readOnly
                              className="form-control" type="text" />
                              {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                            </div>
                          )}
                          </Field>
                        }
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">District:</label>
                        <div className="col-sm-8">
                        { 
                          <Field name="ldsResponseDistrict">
                          {({ input, meta }) => (
                            <div>
                              <input 
                              onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                              {...input} 
                              readOnly
                              disabled={this.state.isDisabled}
                              className="form-control" type="text" />
                              {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                            </div>
                          )}
                          </Field>
                        }
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Console:</label>
                        <div className="col-sm-8">
                        { 
                          <Field name="console" validate={required}>
                            {({ input, meta }) => (
                              <div>
                                <input 
                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                {...input} 
                                disabled={this.state.isDisabled}
                                className="form-control" type="text" />
                                {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        }
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">PLM (if applicable):</label>
                        <div className="col-sm-8">
                          <Field name="plm">
                            {({ input, meta }) => (
                              <div>
                                <input 
                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                {...input} 
                                disabled={this.state.isDisabled}
                                className="form-control" type="text" />
                                {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Estimated Avg Leak Rate:</label>
                        <div className="col-sm-4">
                          <Field 
                            name="estimatedAvgLeakRate" 
                            parse={parse}
                          >
                            {({ input, meta }) => (
                              <div>  
                                <input 
                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                {...input} 
                                disabled={this.state.isDisabled}
                                className="form-control" type="number" />
                                {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                            </div>
                            )}
                          </Field>
                        </div>
                        <div className="col-sm-4">
                          <Field 
                            name="estimatedAvgLeakRateSelect" 
                            options={bph_m3}
                          >
                            { ({input,  meta, options}) => {
                              //console.log(input)
                                return (
                                    <Opts options={options} disabled={this.state.isDisabled} selected={input.value} cssclass="" meta={meta} onChange={ (value) => input.onChange(value)} name={input.name}/>
                                )
                            }}
                          </Field>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Est. Max (if variable)</label>
                        <div className="col-sm-4">
                          <Field 
                            name="estimatedMax" 
                            parse={parse} 
                          >
                            {({ input, meta }) => (
                              <div>      
                                <input 
                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                {...input} 
                                disabled={this.state.isDisabled}
                                className="form-control input-sm" type="number" />
                                {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                        </div>
                        <div className="col-sm-4">
                        <Field name="estMaximumUnit" options={bph_m3}>
                          { ({input,  meta, options,selected}) => {
                              return (
                                <Opts 
                                  options={options} 
                                  disabled={this.state.isDisabled} 
                                  selected={input.value} 
                                  cssclass="" meta={meta} 
                                  onChange={ (value) => input.onChange(value)} 
                                  name={input.name}
                                />
                              )
                          }}
                        </Field>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Est. Min (if variable)</label>
                        <div className="col-sm-4">
                          <Field 
                            name="estimatedMin"
                            parse={parse}
                          >
                            {({ input, meta }) => (
                              <div>
                                <input
                                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                  {...input} 
                                  disabled={this.state.isDisabled}
                                  className="form-control input-sm" type="number" 
                                />
                                {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </div>
                        <div className="col-sm-4">
                          <Field 
                            name="estMinimumUnit"  
                            options={bph_m3}
                          >
                            { ({input,  meta, options}) => {
                                return (
                                    <Opts options={options} disabled={this.state.isDisabled} selected={input.value} cssclass="" meta={meta} onChange={ (value) => input.onChange(value)} name={input.name}/>
                                )
                            }}
                          </Field>
                        </div>
                      </div>
                      
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Leak Detection Time (Time/Date):</label>
                        <div className="col-sm-8">
                          <LeakDetectionTimeComponent isDisabled={this.state.isDisabled} submitInfo={this.state.submitType} /> 
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Swiftness of Detection (hrs)</label>
                        <div className="col-sm-8">
                            <Field 
                              name="swiftnesOfDetection"
                              validate={required}
                            >
                              {({ input, meta }) => (
                                <div>  
                                  <input 
                                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                  {...input} 
                                  disabled={this.state.isDisabled}
                                  className="form-control input-sm" type="text" />
                                  {meta.error && meta.submitFailed && <span className="error_form">{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>

                     
              
              <h4>Leak Detection Systems Reliability Performance:</h4>
              <table border="1" id="leak_detect_table" style={{width:"100%"}}>
                <thead>
                  <tr>
                    <th className="system-col-size">System </th>
                    <th className="operation-col-size text-center">Operational</th>
                    <th className="detect-col-size text-center">Detected</th>
                    <th className="comments-col-size">Comments</th>
                  </tr>
                </thead>
                <tbody className="trfocus">
                {/* {this.state.currentLeakDetectionData.leakDections?.map((r, i) => ( */}
                <FieldArray 
                  name="leakDetections"
                
                //initialValue={this.state.currentLeakDetectionData.leakDections}
                >
                {({ fields }) =>
                  fields.map((name, index) => (
                  <tr key={name} >
                    <td>{this.state.currentLeakDetectionData.leakDetections[index]['noteName']}</td>
                    <td>
                      <div className='disNone'>
                        {/* Hiddent fields start */}
                        <Field name={`${name}.id`} component="input" className="form-control" type="hidden" />
                        
                        <Field name={`${name}.detectionId`}  component="input" className="form-control" type="hidden" />
                        
                        <Field name={`${name}.noteName`} component="input" className="form-control" type="hidden"  />

                        <Field name={`${name}.applicable`} component="input" className="form-control" type="hidden"  />

                        <Field name={`${name}.lastUpdatedDate`} component="input" className="form-control" type="hidden"  />
                        
                        <Field name={`${name}.lastLeakDetectedBy`} component="input" className="form-control" type="hidden"  />
                        
                        <Field name={`${name}.ticketId`} component="input" className="form-control" type="hidden"  />
                            
                      </div>
                      {/* Hiddent fields end */}
                        <Field name={`${name}.operation`}  options={yes_no_na}>
                          { ({input,  meta, options}) => {
                              return (
                                  <Opts options={options} disabled={this.state.isDisabled} selected={input.value} cssclass="
                                  " meta={meta} onChange={ (value) => input.onChange(value)} name={input.name}/>
                              )
                          }}
                        </Field>
                    </td>
                    <td className="center-align-td">
                      {/* <Field name={`${name}.detected`} className="form-control drop-down-field" component="select" >
                        <option value="">Select</option>
                        {yes_no_na.map((x) => {
                            return (
                              <option value={x.value}>{x.text}</option>
                            )
                        })}
                      </Field> */}
                      <Field name={`${name}.detected`} options={yes_no_na}>
                        { ({input,  meta, options}) => {
                            return (
                                <Opts selected={input.value} disabled={this.state.isDisabled} options={options} cssclass="
                                " meta={meta} onChange={ (value) => input.onChange(value)} name={input.name}/>
                            )
                        }}
                      </Field>
                    </td>
                    <td className="center-align-td">
                    <Field name={`${name}.comments`} disabled={this.state.isDisabled} component="textarea" className="form-control h38" />
                        
                        {/* { ({input,  meta}) => {
                          
                            return (
                                <TextArea cssclass="h38" name={input.name}  meta={meta}  onChange={ (value) => input.onChange(value)} onfocus={(value)=>input.onfocus(value)} />
                            )
                        }} */}
                      {/* <textarea className="form-control h38"></textarea> */}
                    </td>
                  </tr>
                ))}
                </FieldArray>
                </tbody>
              </table>
              <h4>Leak Detection Systems Accuracy and Swiftness Performance:</h4>
              <table border="1" >
                <thead>
                  <tr>
                    <th style={{width:"20%"}}>System</th>
                    <th style={{width:"15%"}} className="text-center">Indicated Avg Leak Rate</th>
                    <th style={{width:"10%"}} className="text-center">UOM <br/>(bph/m3/h/N/A)</th>
                    <th style={{width:"10%"}} className="text-center">Expected Swiftness (hrs)</th>
                    <th style={{width:"45%"}} >Comments</th>
                  </tr>
                </thead>
                <tbody className="trfocus">
                {/* {this.state.currentLeakDetectionData.leakDections?.map((r, i) => ( */}
                <FieldArray 
                name="leakDetections"
                
                //initialValue={this.state.currentLeakDetectionData.leakDections}
                >
                {({ fields }) =>
                  fields.map((name, index) => (
                  <tr key={name}>
                    <td>{this.state.currentLeakDetectionData.leakDetections[index]['noteName']}</td>
                    <td>
                    {/* <Field name={`${name}.indicatedAvgLeakRate`} component="input" className="form-control"  /> */}
                      <Field 
                        name={`${name}.indicatedAvgLeakRate`}
                        parse={parse}
                      >
                          {({ input, meta }) => (
                            <div>  
                              <input 
                              onKeyPress={(e) => { 
                                var charCode = e.key;
                                if((charCode.toLowerCase() >= 'a'  && (charCode.toLowerCase() <= 'z')) ){
                                  e.preventDefault();
                                }
                                
                              
                                //e.key === 'Enter' && e.preventDefault(); 
                              }}
                              {...input} 
                              disabled={this.state.isDisabled}
                              className="form-control" 
                              type="number"
                              />
                              {meta.error && meta.submitFailed && <p className="error_form">{meta.error}</p>}
                          </div>
                        )}
                      </Field>
                    </td>
                    <td className="center-align-td">
                      {/* <Field name={`${name}.uom`} className="form-control drop-down-field" component="select" >
                        <option value="">Select</option>
                        {bph_m3h_NA.map((x) => {
                            return (
                              <option value={x.value}>{x.text}</option>
                            )
                        })}
                      </Field> */}
                      <Field 
                        name={`${name}.uom`}
                        options={bph_m3h_NA}
                      >
                        { ({input,  meta, options}) => {
                            return (
                                <Opts selected={input.value} disabled={this.state.isDisabled} options={options} cssclass="
                                " meta={meta} onChange={ (value) => input.onChange(value)} name={input.name}/>
                            )
                        }}
                      </Field>
                      
                    </td>
                    <td>
                    {/* <Field name={`${name}.expectedSwiftness`} component="input" className="form-control"  /> */}
                    
                      <Field 
                        name={`${name}.expectedSwiftness`}
                        parse={parse}
                      >
                          {({ input, meta }) => (
                            <div>  
                              <input 
                              onKeyPress={(e) => { 
                                var charCode = e.key;
                                if((charCode.toLowerCase() >= 'a'  && (charCode.toLowerCase() <= 'z')) ){
                                  e.preventDefault();
                                }
                                
                                //e.key === 'Enter' && e.preventDefault(); 
                              }}
                              {...input} 
                              disabled={this.state.isDisabled}
                              className="form-control" 
                              type="number"
                              />
                              {meta.error && meta.submitFailed && <p className="error_form">{meta.error}</p>}
                          </div>
                        )}
                      </Field>
                    </td>
                    <td className="center-align-td">
                      <Field 
                      name={`${name}.commentsAccuracyPerformance`} 
                      disabled={this.state.isDisabled}
                      
                      component="textarea" className="form-control h38" />
                      {/* <Field name={`leakDetections[${i}][comments]`} options={yes_no_na}>
                        { ({input,  meta}) => {
                            return (
                                <TextArea cssclass="h38" value={r.comments} meta={meta} rows={5} name={input.name} onChange={ (value) => input.onChange(value)}/>
                            )
                        }}
                      </Field> */}
                      {/* <textarea className="form-control h38" rows={"5"}></textarea> */}
                    </td>
                  </tr>
                ))}
                </FieldArray>
                </tbody>
              </table>
              <br />
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Notes:</label>
                <div className="col-sm-8">
                  <Field name={`note`} disabled={this.state.isDisabled} component="textarea" className="form-control" />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Leak Detection Analysis by:</label>
                <div className="col-sm-8">
                  <input type="text" readOnly className="form-control" value={this.state.currentLeakDetectionData.leakDetections!=''?this.state.currentLeakDetectionData['lastUpdateBy']:''} />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Reviewed and Approved by: </label>
                <div className="col-sm-8">
                  <input type="text" readOnly className="form-control" value={this.state.currentLeakDetectionData.reviewApprovedBy!=''?this.state.currentLeakDetectionData.reviewApprovedBy:''} />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Approved on: </label>
                <div className="col-sm-8">
                  <ApprovedOnComponent isDisabled={this.state.isDisabled} />
                </div>
              </div>
            
            <div className='col-md-12 incidentpopupbuttons '>
                <div className="row btn-toolbar justify-content-center">
                  {renderApproverButton(submitting,getState)}
                  {/* {saveSubmitApproval()} */}
                  {/* <button class="btn btn-primary btn-grid active" type="submit" onClick={()=>this.setState({submitType:1})} disabled={submitting}><FontAwesomeIcon icon={faSave} /> Save</button>
                  <button class="btn btn-primary btn-grid active w189 " type="submit" onClick={()=>this.setState({submitType:2})} ><FontAwesomeIcon icon={faSave} /> Submit for Approval</button>
                  <button class="btn btn-primary btn-grid active" type="button" onClick={()=>this.handleDownloadExcel(getState().values)}><FontAwesomeIcon icon={faFileExport} /> Export</button>
                  <button class="btn btn-primary btn-grid active" onClick={this.closeModal} type="button"><FontAwesomeIcon icon={faSync} /> Cancel</button> */}
                </div>

                <div className="row btn-toolbar justify-content-center">
                  {/* {renderApproverButton()}     */}
                  {/* <button class="btn btn-primary btn-grid active" type="button"><FontAwesomeIcon icon={faSave} /> Save</button>
                  <button class="btn btn-primary btn-grid active" type="button" onClick={()=>this.onApproveReject(3)}><FontAwesomeIcon icon={faSave}  /> Approve</button>
                  <button class="btn btn-primary btn-grid active" type="button" onClick={()=>this.onApproveReject(4)}><FontAwesomeIcon icon={faCircleNotch}  /> Reject</button>
                  <button class="btn btn-primary btn-grid active" type="button" onClick={()=>this.handleDownloadExcel(getState().values)}><FontAwesomeIcon icon={faFileExport} /> Export</button>
                  <button class="btn btn-primary btn-grid active" onClick={this.closeModal} type="button"><FontAwesomeIcon icon={faSync} /> Cancel</button> */}
                </div>
              </div>

                      {/* <Field name="firstName" >
                        {({ input, meta }) => (
                          <div>
                            <label>First Name</label>
                            <input {...input} type="text" placeholder="First Name" />
                            {meta.error && meta.touched && <span>{meta.error}</span>}
                          </div>
                        )}
                        </Field>
                        <Field name="lastName" >
                          {({ input, meta }) => (
                            <div>
                              <label>Last Name</label>
                              <input {...input} type="text" placeholder="Last Name" />
                              {meta.error && meta.touched && <span>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                        <Field
                          name="age"
                          validate={composeValidators(required, mustBeNumber, minValue(18))}
                        >
                          {({ input, meta }) => (
                            <div>
                              <label>Age</label>
                              <input {...input} type="text" placeholder="Age" />
                              {meta.error && meta.touched && <span>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                        <div className="buttons">
                          <button type="submit" disabled={submitting}>
                            Submit
                          </button>
                          <button
                            type="button"
                            onClick={form.reset}
                            disabled={submitting || pristine}
                          >
                            Reset
                          </button>
                        </div>
                        <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                      </form>
                    )}
                  />
            </Container>
          </Modal.Body>
          <Modal.Footer>
            
          </Modal.Footer>
        </Modal>
          <div className='releaseIncidentGrid'>
            <div className="row">
              {screenRowData.ReleaseIncidentData && (
                <AgGrid
                  gridID={"releaseIncidentData"}
                  gridOptions={this.state.gridOptions}
                  columnDefs={colDef}
                  rowData={screenRowData.ReleaseIncidentData}
                  onSelectionChanged={this.onSelectionChanged}
                  onCellValueChanged={this.onCellValueChanged.bind(this)}
                />
              )}
            </div>
          </div>
        <div className="row btn-toolbar pull-right">
          <button
            type="button"
            className="btn btn-primary btn-grid active"
            aria-expanded="false"
            disabled={!hasScreenData}
            onClick={this.exportToExcel}
          >
            Export
          </button>

        </div>
      </div>
    );
  }

  
  saveVendorTemplateData = async () => {
    // console.log("col state", JSON.stringify(this.state.towerKPIGridOptions.columnApi.getColumnState()))
    const { vendorlistTxt } = this.state;
    const { CommonStore, VendortTemplateDataStore } = this.props;

    const parentScreenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await VendortTemplateDataStore.saveScreenData(currentScreen, CommonStore);
    await this.getReleaseIncidentsData();
  };
  onCellValueChanged = (e) => {

    if (e.newValue !== null && e.oldValue != e.newValue) {
      this.state.gridOptions.api.refreshCells();
    }
    else {
      e.node.setDataValue(e.colDef.field, e.oldValue);
      this.state.gridOptions.api.refreshCells();
    }
    e.node.setDataValue("IsModified", true);
    e.node.data.IsModified = true;
  };
  formatExportValues = (params) => {
    switch (params?.column?.colId) {
      case "incidentDate":
      case "reportDate":
        return params?.value
          ? moment(params?.value).format("MMM DD, YYYY h:mm a")
          : "";
      default:
        return params?.value;
    }
  };
  exportToExcel = () => {

    const { CommonStore, ReleaseIncidentDataStore } = this.props;

    const parentScreenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );

    let params = {
      allColumns: false,
      onlySelected: false,
      onlySelectedAllPages: false,
      shouldRowBeSkipped: false,
      skipFooters: false,
      skipGroups: true,
      skipHeader: false,
      skipPinnedTop: false,
      skipPinnedBottom: false,
      fileName: parentScreenName
    };
    var today = new Date();
    const formattedDate = moment(today).format('YYYYMMDDhhmmss');
    const currentSheet = parentScreenName;
    let fileNameExcelExport = currentSheet + '_Export_All_' + formattedDate + '';

    const visibleColumns =
      this.state.gridOptions.api.gridOptionsWrapper.columnApi.getAllDisplayedColumns();
    const columnsToExport = visibleColumns
      .filter((item) => item.colId !== "ticketUId")
      .filter((item) => item.colId !== "Upload")
      .map((item) => item.colId);
    this.state.gridOptions.api.exportDataAsExcel({
      fileName: fileNameExcelExport,
      sheetName: currentSheet,
      processCellCallback: this.formatExportValues,
      columnKeys: columnsToExport,
    });

  };

  componentDidMount = async () => {
    await this.refreshHeader();
    await this.setColumnDef();
    await this.approverApi();

    // const { location } = this.props;
    // let event_id = (new URLSearchParams(location.search).get('event_id'));
    const queryParams = new URLSearchParams(window.location.search);
    var event_id= this.props.computedMatch.params.event_id;

    if(typeof event_id!='undefined' && event_id!='' && event_id!=null){
      const { CommonStore, ReleaseIncidentDataStore } = this.props;
      //GetIncidentByEvent
      let sData = await ReleaseIncidentDataStore.GetIncidentByEvent(event_id,CommonStore);
      //console.log('sData',sData);

      if(typeof sData['data']!='undefined' && sData['data']!='')
        await this.showLeakDetection(sData['data'][0]);
    }
  };

  componentWillUnmount() {
    ReleaseIncidentDataStore.resetReleaseIncidentData();
  };

  /* Approver API */
  approverApi = async () => {
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN');
    const roleObj = JSON.parse(jsonStringOBJ);
    const { userName } = roleObj;
    
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    let approvercall = await ReleaseIncidentDataStore.getApproverAPI(CommonStore);
    if(typeof approvercall.data!='undefined' && approvercall.data!=''){
      //console.log(approvercall);
      let s = (approvercall.data).split(";");
      let words = s.map(v => v.toLowerCase());
      let n = userName.toLowerCase();
      let status = (words).includes(n);
      this.setState({approverStatus:status});
      // console.log('userName',n);
      // console.log('API data',words);
      // console.log('approvecall',status);
    }
    
  };

  refreshHeader = async () => {
    const { CommonStore, ReleaseIncidentDataStore } = this.props;
    await ReleaseIncidentDataStore.getGetEventYear(CommonStore);
  };
  getCurrentScreenParent = () => {
    const parentScreenName = this.props.path.split('/').pop();
    const parentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === parentScreenName
    );

    return parentScreen;
  };


}

const WhenFieldChanges = ({ field, becomes, set, to }) => (
  <Field name={set} subscription={{}}>
    {(
      // No subscription. We only use Field to get to the change function
      { input: { onChange } }
    ) => (
      <FormSpy subscription={{}}>
        {({ form }) => (
          <OnChange name={field}>
            {value => {
              if (value === becomes) {
                onChange(to);
              }
            }}
          </OnChange>
        )}
      </FormSpy>
    )}
  </Field>
);

export const Opts = (props) => {
  return (
    <div>
      <select name={props.name} meta={props.meta.error} disabled={props.disabled} onChange={props.onChange} className={"form-control "+props.cssclass}  >
        <option value="">Select</option>
          {props.options.map((x) => {
              return (
                <option  key={x.key} selected={((typeof props.selected) && props.selected==x.key ?'selected':'' ) } value={x.value}>{x.text}</option>
              )
          })}
      </select>
      {(props.meta.error && props.meta.touched) && <span className="error_form">{props.meta.error}</span>}
    </div>
  )
};

export const TextBox = ({ input, meta }) => (
  <div>
    <input
      {...input}
      type="text"
      data-testid="text-input"
     className={meta.error && meta.touched ? "errors" : ""}
    />
  {meta.error && meta.touched && <p className="error">{meta.error}</p>} 
  </div>
);

/* 
  <textarea
                      value={this.props.NGLTeamDailyReportStore.actionItemReview}
                      maxLength="8000"
                      className="form-control"
                      id="ActionItemReview"
                      rows="5"
                      onInput={(event) => {
                        this.props.NGLTeamDailyReportStore.actionItemReview = event.target.value;
                      }}
                      placeholder={"Please add meeting notes here"}
                    />

*/

export const TextArea = ({ name,value, meta,cssclass,onChange }) => (
  <div>
    <textarea
      name={name}
      className={`form-control `+cssclass} 
      onChange={onChange}
      rows="5"
      maxLength="8000"
      
    >{value}</textarea>
    {meta.error && meta.touched && <p className="error_form">{meta.error}</p>} 
  </div>
);

/* DATEPICKER */
export const RenderDatePicker = ({ name, input, input: { value, onChange } }) => {
  return (
    <DatePicker
      locale="en"
      placeholderText=""
      dateFormat="yyy-MM-dd HH:mm:ss"
      selected={input.value && isValid(input.value) ? toDate(input.value) : null} // needs to be checked if it is valid date
      value={input.value}
      //selected={value}
      //value={value}

      disabledKeyboardNavigation
      name={input.name}
      showTimeInput
      //showTimeSelect
      shouldCloseOnSelect={false}
      className="form-control"
      timeInputLabel="Time:"
      
      onChange={(date) => {
        // On Change, you should use final-form Field Input prop to change the value
        if (isValid(date)) {
          //console.log('selected',date);
          //input.onChange(format(new Date('2022-08-11 21:10:02'), "yyy-MM-dd HH:mm:ss"));
          //input.onChange(format(new Date(date), "yyy-MM-dd HH:mm:ss"));
          input.onChange(moment(date).format('YYYY-MM-DD HH:mm:ss'));
          //console.log('A value',a);
          //console.log('after',input.value)
        } 
        else {
          input.onChange(null);
        }
      }}
    />
  );
};

export default ReleaseIncidentScreen;